// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"37":"227a5b2a","230":"6c4f74b0","376":"d015197c","771":"e47906f0","992":"ecd02001"}[chunkId] + ".chunk.css";
};